export enum Language {
  ENGLISH = 'en',
  ARABIC = 'ar',
}

export const LanguageLabels: Record<Language, string> = {
  [Language.ENGLISH]: 'English',
  [Language.ARABIC]: 'العربية',
};

export const RTL_LANGUAGES: Language[] = [Language.ARABIC];
